import * as React from 'react';
import {Dispatch, useEffect, useState} from "react";

type selectCityInterface = {
    selectedCity: string;
    setSelectedCity: Dispatch<any>;
    cityError: boolean;
    setCityError: Dispatch<any>;
    setManualTrashSize: Dispatch<any>;
    setManualTrashPrice: Dispatch<any>;
    photoUploadSection: any;
    apiUrl: string;
};

interface CityOption {
    id: number;
    name: string;
}

export const AIAnalyseDescription = ({
                                         selectedCity,
                                         setSelectedCity,
                                         cityError,
                                         setCityError,
                                         setManualTrashSize,
                                         setManualTrashPrice,
                                         photoUploadSection,
                                         apiUrl
                                     }: selectCityInterface) => {

    const [cities, setCities] = useState<CityOption[]>([]);

    useEffect(() => {
        const controller = new AbortController();
        const options = {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            signal: controller.signal
        };
        fetch(apiUrl + 'cities', options)
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then((data) => setCities(data))
            .catch(() => setCities([]));

        return () => controller.abort();
    }, [apiUrl]);

    const handleCitySelection = (event: any) => {
        setSelectedCity(event.target.value);
        setCityError(false);
        setManualTrashSize('');
        setManualTrashPrice('');
        photoUploadSection.current?.scrollIntoView({behavior: 'smooth'});
    };

    return (
        <>
            <div id="ai-analyse-description">
                <p><strong>Pasirinkite miestą: </strong></p>
                <div className="hero-pills">
                    {cities.map((city, index) => (
                        <div key={city.id}
                             className={(selectedCity == city.name ? "activeCity" : "") + (cityError ? " city-error" : "")}>
                            <input id={`city${index + 1}`} type="radio" name={"city"} value={city.name}
                                   onChange={handleCitySelection}/>
                            <label htmlFor={`city${index + 1}`}>{city.name}</label>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

